export interface BaseConfig {
  identityServerUrl: string;
  clientDomains: BaseConfigClientDomain[];
}

export interface BaseConfigClientDomain {
  domain: string;
  client: string;
}
